import { LanguageFileType } from "types/Common";

const en_gb: LanguageFileType = {
  code: "gb",

  AboutMain:
    "At EasyPartz we have decided to modernize the way you order CNC milled parts. Through automation and digital tools, we help you to easily and quickly transition from idea to a physical product.",
  AboutSub:
    "We are constantly working to widen our assortment and capacity, so if you have any inquiries, you are welcom to contact us.",
  AboutTitel: "About easypartz",
  AboutUs: "About Us",
  AddComponent: "Add component",
  AddToBasket: "Add to basket",
  AgreeButton: "Accept",
  Aluminium5058: "Aluminium 5083",
  Aluminium5083Desc:
    "5083 aluminum alloy is an aluminum alloy with magnesium and traces of manganese and chromium. It is highly resistant to attack by seawater and industrial chemicals.",
  Aluminium6082: "Aluminium 6082",
  Aluminium6082Desc:
    "Aluminum alloy 6082 is a medium-strength alloy with excellent corrosion resistance. It has the highest strength of alloys in the 6000 series. Alloy 6082 is known as a structural alloy.",
  Aluminium7075: "Aluminium 7075",
  AluminiumTitel: "ALUMINIUM",
  Amount: "Amount",
  AnErrorOccurredCantUpdate:
    "An error occurred, and the product could not be updated. Check your internet connection and try again later.",
  Basket: "Basket",
  Checkout: "Checkout",
  BasketEmpty: "Your basket is empty",
  BasketCardHeader: "Basket",
  BeadBlast: "Bead Blasting",
  Brass58: "Brass 58",
  ButtonBack: "Back",
  ButtonOk: "Okay",
  CancelButton: "CANCEL",
  Cases: "Cases",
  CasesMain:
    "Read more about EasyPartz helps insurenace, development, and production departments progress faster.",
  ChangeBlueprint: "CLICK TO CHANGE BLUEPRINT",
  CheckoutBasketEmpty: "Your basket is empty...",
  CityInput: "City",

  // Component Configuration
  AddComment: "Add comment",
  CLickAddComment: "Click to add comment",
  Comment: "Comment",
  CompConfigAddedingToBasket: "Adding your configuration to the basket...",
  AddNewCompButton: "Add new component",
  CompConfigBlueprintButton: "Blueprint",
  CompConfigCompAddedToBasket:
    "Your configuration has been added to your basket!",
  CompConfigConfidentiality:
    "All files are securely processed and confidential",
  CompConfigMaterialButton: "Material",
  CompConfigReturningToBasket: "Returning to basket...",
  CompConfigSlowLoadMsg:
    "The calculations for your model are still going, but is taking longer than usual...",
  CompConfigSucces: "Succes",
  ThreeDModelButton: "3d-model",
  CompConfigUpadateingComp: "Updating your configuration...",
  CompConfigUpdated: "Your configuration has been updated",
  CompConfigUpdatedGoToBasketButton: "GO TO BASKET",
  Delete: "Delete",
  Edit: "View & Edit",
  PasswordChangedSuccess: "Your password was succesfully changed.",
  PasswordChangedError: "Your password could not be changes. Please try again.",
  // Configurator Summary Card
  ConfiguratorPriceEachPiece: "per. pcs.",
  ConfSummaryPriceTotal: "Price (excl. vat)",
  ConfSummaryDays: " days",
  ConfiguratorPriceFinishToolTip: "The extra cost for the finish chosen",
  ConfiguratorPriceHandelingToolTip: "Standard fee for handling your order",
  ConfiguratorPriceHandling: "Handling",
  Material: "Material",
  ConfiguratorPriceMaterialToolTip:
    "The cost of the material manufacture your component",
  ConfiguratorPriceProduction: "Production",
  ConfiguratorPriceProductionToolTip:
    "The cost of the time it takes to manufacture your component",
  ConfiguratorPriceSetup: "Setup",
  ConfiguratorPriceSetupToolTip:
    "The cost of preparing the CAM file for setting up our CNC machine",
  ConfSummaryModel: "Model",
  ConfSummaryConfiguration: "Configuration",
  ConfSummaryQuantity: "Quantity",
  ConfSummaryDelivery: "Production time",
  ConfLeadTimeSubText: "Applies to the entire order",
  ConfSummaryPrice: "Price",
  ConfiguratorPriceErrorMsg: "Possible Manufacturing Issues",
  ConfiguratorPriceCanNotGuarantee:
    "Your order will be manually checked to ensure it can be manufactured. We will contact you if there are any issues.",
  ConfiguratorPriceCanNotGuarantee2:
    "Feel free to contact us through phone at +45 60858075 or email info@easypartz.com if you have questions.",

  ConfiguratorPriceSummaryFinishPomMsg: "NOT POSSIBLE FOR POM",
  ConfiguratorPriceSummaryTitel: "SUMMARY",
  ConfiguratorPriceSummaryTitelSmall: "Summary",
  ConfirmOrderButton: "Make order",
  ConfirmPassword: "Confirm password",
  Confirm: "Confirm",
  CookiePreferences: "Cookiepreferences",
  CookiePreferencesChange: "Change Cookiepreferences",
  CreateNewUserBody:
    "Create a user and follow your orderstatus, reorder earlier configured parts or order new parts faster.",
  CreateNewUserTitel: "Create New User",
  CreateUserButton: "CREATE USER",
  CreatingUserMsg:
    "We are creating your user and moveing your guest basket over - One moment...",
  CVRInput: "CVR-Number",
  Dashboard: "Dashboard",
  DashboardNavBarToolTipClose: "CLOSE SIDEMENU",
  DashboardNavBarToolTipOpen: "OPEN SIDEMENU",
  Delivery: "Delivery",
  DeliveryMethod: "DELIVERY METHOD",
  DeliveryMethodLower: "Delivery method",
  DesignGuide: "DESIGN GUIDE",
  DemoButton: "3D Demo",
  DemoModeText: "Demo used",
  // DFM Error Descriptions
  DFMErrorsFound: "Design Issues",
  DFMErrorMultipleSolidsTitle: "Multiple Solids",
  DFMErrorMultipleSolidsDesc:
    "Multiple solids were detected in the file. Our calculator can only handle 1 solid at a time. Please contact us through phone or mail if you have any questions.",
  DFMErrorNoSolidsTitle: "No Solids",
  DFMErrorNoSolidsDesc:
    "No solids were detected in the file. This can be because the model only consists of faces. Please contact us through phone or mail if you have any questions.",
  DFMErrorOverdimensionTitle: "Dimensions",
  DFMErrorOverdimensionDesc1:
    "The model is larger than our guaranteed maximum dimensions of 600mm x 500mm x 80mm. The model might still be possible to manufacture.",
  DFMErrorOverdimensionDesc2:
    "After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorUnderdimensionTitle: "Dimensions",
  DFMErrorUnderdimensionDesc1:
    "Modellen er mindre end vores garanterede minimums dimensioner på 8mm x 8mm x 2mm.",
  DFMErrorUnderdimensionDesc2:
    "After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorEdgeTitle: "Edges",
  DFMErrorEdgeDesc:
    "Edges which may be difficult to manufacture were detected. Internal Edges should be rounded to at least 1mm radius. After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorFaceTitle: "Faces",
  DFMErrorFaceDesc:
    "Edges which may be difficult to manufacture were detected. The faces might be possible to manufacture using 5-axis machining or custom tools. After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorPointTitle: "Points",
  DFMErrorPointDesc:
    "Points which may be difficult to manufacture were detected. Internal Points should be rounded to at least 1mm radius. After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorThinPlaneTitle: "Thin Walls",
  DFMErrorThinPlaneDesc:
    "Faces with thin walls (<0.9mm) which may be difficult to manufacture were detected. Faces should be at least 1mm thick to ensure stability. After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorDeepTitle: "Deep Pockes",
  DFMErrorDeepDesc:
    "Deep Pockets which may be difficult to manufacture were detected. Pockets should not be deeper than 5x their width. After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",
  DFMErrorClearanceTitle: "Small Clearances",
  DFMErrorClearanceDesc:
    "Faces with small clearances (<1.9mm) to each other which may be difficult to manufacture were detected. Faces should have at least 2mm clearance to avoid requiring special tools. After ordering the model will be manually inspected. Please contact us through phone or mail if you have any questions.",

  Diameter: "Diameter",
  DisagreeButton: "Reject",
  Disabled: "Disabled",
  DiscountCode: "Discount Code",
  Discount: "Discount",
  Email: "Email",
  EmailFaktura: "Send kopi af faktura til:",
  EmptyBasket: "CLEAR",

  // Error messages
  ErrorOnUpload:
    "Your model could not be processed. Please check that the model is correct. If the problem is not solved, please contact us at info@easypartz.com",
  Error: "ERROR",
  ErrorBasketCouldNotBeEmptyed:
    "Product could not be removed from your basket because error: ",
  ErrorBasketCouldNotBeFetched:
    "Your basket could not be fetched becuse of error: ",
  ErrorCalcDeliveryPrice:
    "An error occurred while calculating the delivery price ",
  ErrorCantUpdate:
    "An error occurred, so the product could not be updated. Check your internet connection and try again later.",
  ErrorCheckInternetTryAgain:
    ". Check your internet connection and try again later.",
  ErrorCouldNotAddCompBecause:
    "The product could not be added to basket because: ",
  ErrorCreatingID: "Identification number could not be created: ",
  ErrorDesc: "oooups! Looks like you got lost.",
  ErrorFileToBig: "An error occurred, so the price could not be calculated.",
  ErrorFinishingOrder: "An error occurred during the completion of your order ",
  ErrorGettingUser: "An error occurred trying to get your account information ",
  ErrorGuestBasketCouldNotBeTransferd:
    "Your guest basket could not be transfered to to your new user - ",
  ErrorMsg: "An error occurred...",
  ErrorOccurred: "An error occurred: ",
  ErrorSettingUpAddress:
    "An error occurred during the creation of your address ",
  ErrorSub: "Page not found :(",
  ErrorUpdatingUser:
    "An error occurred trying to update your account information ",
  ExcludingMoms: "(Excl. VAT)",
  ExpiredSessionLogIn: "Your session has expired - You have to log in again...",
  Filename: "File name",
  Finish: "Finish",
  Anodizing: "Anodizing",
  FinishSelectionAnodizeDesc:
    "The material is anodized so that it is better protected against corrosion",
  FinishSelectionBeadBlastDesc:
    "The material is Bead Blasted, so it gets a smooth and matte finish",
  NoFinish: "No finish",
  NoFinishDesc: "The material is not further treated",
  FinishSelectionPOMErr:
    "It is not possible to choose extra finishes of POM plastic",
  FinishStandard: "STANDARD",
  FirmNameInput: "Company",
  FirstName: "First name",
  ForgottenPassword: "Have you for forgotten your password?",
  ForgottenPasswordMsg:
    "Enter your email and we will send you an email where you can reset your password, if your account exists in our system.",
  FrontPage: "Front page",
  FrontPageMainText:
    "Easy online ordering of CNC milled parts in high quality - instant price calculation and fast delivery times",
  FrontPageSubText: "Try now and receive a price right away!",
  FrontPageTitel: "YOUR ONLINE MACHINE SHOP",
  HelpBody:
    "If you're in doubt about what parameters are important for your components to be produced to the highst possible satisfaction, you have come to the right place. We have collected the most common questions, that might help you solve your problem.",
  HelpBody2_1:
    "Should you have any further questions or uncertainties about if your component can be produced, you are most welcome to write to us at",
  HelpBody2_2: " or call at ",
  HelpCancelBody: "v1.0.0",
  HelpCancelTitel: "How do i cancel my order?",
  HelpPaymentBody: "v1.0.0",
  HelpPaymentTitel: "How do i pay?",
  HelpPriceBody:
    "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor.",
  HelpPriceTitel:
    "Why can't you give me a price for my component/configuration?",
  HelpThreadBody: "v1.0.0",
  HelpThreadTitel: "How to i specify threads?",
  HelpTitel: "Help",
  HelpUploadBody:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat, ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus. In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae. Fusce sed commodo purus, at tempus turpis.",
  HelpUploadTitel: "What file types can i upload?",
  IAcceptEasy: "I accept EasyPartz's ",
  IJoinNews: "I want to sign up for EasyPartz's newsletter ",
  InvoiceInfoBillingAddress: "Billing address",
  InvoiceInfoCheckboxText: "Send the wares to another address?",
  InvoiceInfoDeliveryAddress: "Delivery address",
  InvoiceInfoTitel: "BILLING INFORMATION",
  LastName: "Last name",
  ResetPassword: "Reset password",
  RememberMe: "Remember me",
  Login: "Login",
  LoginButton: "LOG IN",
  LoginMissingInfo:
    "Please enter both your email and password before logging in.",
  LoginWrongCredentials: "Wrong email or password.",
  LoginForgetGuestBasket: "FORGET MY GUEST BASKET",
  LoginGuestBasketTrue: "You have components in your guest basket!",
  LoginGuestBasketTrueBody:
    "Do you want to transfer your guest basket to your own basket?",
  LoginInfoMissing: "You forgot to type your log in information!",
  LoginTransferGuestBasket: "TRANSFER MY GUEST BASKET",
  LoginWaitMsg: "Logging you in... please wait",
  LogIn: "LOG IND",
  LogOut: "LOG OUT",
  LogoutBody: "ARE YOU SURE YOU WANT TO LOGOUT?",
  MaterialCardDeliveryHigh1: "Delivery time delayed with ",
  Days: "days",
  MaterialCardDeliveryLow: "Delivery time not affected.",
  MaterialCardDeliveryMed: "Delivery time delayed with +1 day",
  MaterialCardInStock: "In stock.",
  MaterialCardNotInStock: "Not in stock.",
  MaterialCardStatus1: "In stock",
  MaterialCardStatus2: "1 day",
  MaterialCardStatus3: "+3 days",
  Milimeter: "mm",
  MissingConfirmPassword: "You have not confirmed your password",
  ConfirmPasswordDifferent: "Your passwords are not the same",
  InvalidPasswordToken: "Your token is expired. Please request a new email.",
  MissingEmail: "Missing Email",
  MissingPasswordField: "Missing Password",
  MissingConfirmPasswordField: "Missing Confirm Password",
  MissingPhone: "Missing Phone Number",
  MissingFirstName: "Missing First name",
  MissingLastName: "Missing Last name",
  MissingCVR: "Missing CVR number",
  MissingCompany: "Missing Company name",
  MissingRoad: "Missing Road",
  MissingZip: "Missing Zip code",
  MissingCity: "Missing City",
  MissingPassword: "Minimum 8 characters with 1 capital letter",
  MissingFakturaEmail: "Missing faktura email",
  MomsExcluded: "Excl. VAT",
  MomsIncluded: "TOTAL INCL. VAT",
  MomsIncludedSmall: "inkl. moms",
  MyProfile: "MY PROFILE",
  MyProfileSmaller: "My Profile",
  MyProfileCompanyInfo: "Company information:",
  MyProfileContactInformation: "Contact Information",
  MyProfileContactPerson: "Contact Person:",
  CVR: "CVR",
  MyProfileNoStandardAddress: "No standard address",
  MyProfileNotSpecified: "Not specifed",
  MyProfilePhone: "Tel .: ",
  MyProfileText:
    "Here you are able to change your standard address. It will automatically be added as delivery address before payment:",
  MyProfileUpdateButton: "UPDATE ACCOUNT NFORMATION",
  MyProfileCheckbox: "Save an alternative address for use with deliveries?",
  MyProfileBaseInfo: "User information",
  NeedHelp: "NEED HELP?",
  NewComponent: "New component",
  Configurator: "Configurator",
  ConfiguratorCNC: "CNC",
  ConfiguratorPrint3D: "3D print",
  NextButton: "Next",
  NoButton: "No",
  NotReady: "Not ready",
  ConfSummaryCalculating: "Calculating...",
  OfferingCNC: "CNC",
  OfferingCNCText: "Professional CNC machining",
  Dimensions: "Dimensions",
  OfferingDimensionsText: "600mm x 500mm x 80mm",
  OfferingMaterialTitel: "MATERIALS",
  OfferingOrderStatus: "Order status",
  OfferingOrderStatusText: "Always keeping you up to date",
  OfferingPrecision: "Precision",
  OfferingPrecisionText: "ISO 2768 (f) - down to 0.02mm",
  OfferingPriceCalc: "Price calculator",
  OfferingPriceCalcText: "Instant price and feedback",
  OfferingProductionTime: "Production time",
  OfferingProductionTimeText: "Minimum 3 days",
  OfferingService: "SERVICE",
  OfferingTechnology: "TECHNOLOGY",
  OrderComment: "Order comment",
  OrderDetails: "Order details for",
  OrderDetailsDialogAddedToBasket: "Added to basket",
  OrderDetailsDialogAddedToBasketBody:
    "The chosen wares has been added to your basket",
  OrderDetailsDialogAddingToBasket: "Adding your wares to the basket...",
  OrderDetailsDialogAddX1: "ADD ",
  OrderDetailsDialogAddX2: " WARES TO BASKET",
  OrderDetailsDialogPayNowBtn: "Pay",
  OrderDetailsDialogAcceptQuoteBtn: "Accept",
  OrderDetailsDialogErr: "An error has occurred: ",
  OrderDetailsDialogErrInternet:
    ". Check your internet connection and try again later.",
  OrderDetailsDialogMark: "MARK THE WARES YOU WISH YO REORDER",
  OrderDetailsMatFin: "Material / Finish",
  OrderDetailsTitel: "ORDER DETAILS",
  OrderDetailsTitelLower: "Order Details",
  OrderHistory: "ORDERHISTORY",
  OrderHistorySmall: "Order History",
  OrderHistoryCheckSpamMsg:
    "Check your inbox - it can have ended in your 'SPAM' - folder.",
  OrderHistoryDate: "DATE",
  OrderHistoryOrderNumber: "ORDER NUMBER",
  OrderHistoryReceiver: "RECIPIENT",
  OrderHistoryResend: "RESEND INVOICE",
  OrderHistoryResendt: "Your invoice has been resent",
  OrderHistoryResendtError:
    "The invoce was not resendt correctly - check your internet connection and try again...",
  OrderHistoryStatus: "STATUS",
  OrderStatusPending: "Pending",
  OrderStatusProcessing: "Approved",
  OrderStatusComplete: "Completed",
  OrderStatusCancelled: "Cancelled",
  OrderStatusUnpaid: "Missing payment",
  OrderStatusQuote: "Quote",
  Outer: "Outer",
  PANylon: "PA-NYLON",
  Password: "Password",
  PaymentMethod: "PAYMENTMETHOD",
  PaymentMethodLower: "Payment method",
  PaymentBankTransfer: "Bank Transfer / Invoice",
  PaymentBankTransferSubTitle: "Payment due 14 days after shipping",
  PaymentCardTransfer: "Card Payment",
  PaymentEAN: "EAN payment",
  PaymentEANSubtitle: "Pay via GLN(EAN) number",
  PaymentOffer: "Quote by mail",
  PaymentOfferSubtitle:
    "The order will be processed after the quote has been accepted",
  PaymentDeliveryNotice:
    "*Please note that delivery time is excl. our production time!",
  PaymentMissingUser: "You need to create an account",
  PaymentNoUserBody:
    'If you would like to place an order and gain full access to our smart & "My Dashboard", simply enter a password below:',
  PaymentOrderConfirmed:
    "Your order has been received - you will receive an order confirmation from us within a few minutes",
  PaymentThanks: "Thank you for your order!",
  PaymentFailed:
    "Payment failed. Try again from your orderhistory or contact us for help.",
  PdfSubtitle: "Add a blueprint to specify additional features.",
  PdfExpense: "An additional 50 kr. will be added to your price.",
  PEEKNatural: "PEEK-NATURAL",
  PhoneInput: "Phone number",
  PiecePrice: "PCS. PRICE",
  PlasticTitel: "PLASTIC",
  PleaseWait: "Please wait...",
  POMBlack: "BLACK POM-C",
  POMBlackDesc:
    "Black POM-C is a rigid, hard and resilient material, which is suitable for machining. It is short-tipped and a high surface finish can be achieved.",
  POMWhite: "WHITE POM-C",
  POMWhiteDesc:
    "White POM-C is a rigid, hard and resilient material, which is suitable for machining. It is short-tipped and a high surface finish can be achieved.",
  PostNordDelivery: "PostNord Erhverv",
  PostNordDeliveryText: "We will ship using PostNord Erhverv to your address",
  PostNordDeliveryTime: "1-2 business days",
  Price: "Price",
  PriceAfter: "PRICE AFTER",
  PriceBefore: "PRICE BEFORE",
  ProductName: "Product",
  ProductComment: "Comment",
  PTFEWhite: "PTFE-WHITE",
  Reconfigure: "GENCONFIGURERING",
  RoadInput: "Road",
  RoadNumberInput: "Number",
  SelfCollect: "Collect at EasyPartz",
  SelfCollectText: "Collect at our address Maskinvej 2860 Søbrog.",
  SelfCollectTime: "We will contact you when the order is ready for pickup",
  SendLinkButton: "SEND LINK",
  ShippingCardTime: "Delivery time*: ",
  Shipping: "Shipping",
  SidebarEmptyBasket: "EMPTY BASKET",
  SidebarOnlyForUsersText: "ONLY AVAILABLE TO USERS",
  SoftMetal: "Soft metals",
  SomethingWentWrong: "Something went wrong",
  SomethingWentWrongBody:
    "Something went wrong during checkout. Please try again from your orderhistory or feel free to contact us",
  SpecialOfferBody1:
    "With this basket we might be able to give you a better offer.",
  SpecialOfferBody2: "If you want to hear more contact os at: ",
  SpecialOfferTitel: "Special Offer",
  StdErrorMsg:
    " - We have received the error, and will try to fix it. Try 'refreshing' the page",
  Subtotal: "Subtotal",
  SupportsStepFiles:
    "File types: STEP, STP File size: < 12 MB File amount: < 10 Part size: < 3000*3000*3000 mm",
  SupportsStepFilesNew:
    "File types: STEP, STP.  |  Max. file size: 12 MB.  |   Max. amount:  10   |   Max. part size:  3000*3000*3000 mm",
  PrivacyPolicy: "Privacy Policy",
  TermsAndConditions: "Terms and Conditions:",
  TermsAndConditionsSub1: "Field of application",
  TermsAndConditionsSub10: "Guarantee",
  TermsAndConditionsSub11: "Limitation of liability",
  TermsAndConditionsSub12: "Product liability",
  TermsAndConditionsSub13: "Venue and choice of law",
  TermsAndConditionsSub14: "Deviation",
  TermsAndConditionsSub2: "Offer",
  TermsAndConditionsSub3: "Prices",
  TermsAndConditionsSub4: "Payment terms",
  TermsAndConditionsSub5: "Retention of title",
  TermsAndConditionsSub6: "Delivery",
  TermsAndConditionsSub7: "3D files and blueprints",
  TermsAndConditionsSub8: "Complaints",
  TermsAndConditionsSub9: "Return policy",
  TermsAndConditionsSubText1:
    "The following terms of sale and delivery apply to all offers, sales and deliveries from EasyPartz ApS (hereinafter referred to as 'seller'), which operates EasyPartz.com, unless otherwise agreed in writing.",
  TermsAndConditionsSubText10:
    "Seller does not provide warranty unless otherwise agreed in writing.",
  TermsAndConditionsSubText11:
    "Seller disclaims to the fullest extent all possible liability for any loss and any damage that buyer or others may suffer, be it direct or indirect, as a result of the use of the delivered product. To the extent the seller may be liable to the buyer or others, this liability is limited to the direct loss, and the seller is thus not liable for loss of turnover, operating loss, loss of time, loss of profit or similar indirect losses, including due to delay in delivery or defects in the item for sale. A possible claim for compensation against the seller can not exceed the invoice amount incl. VAT for the item sold. Seller shall not be liable for failure to fulfill its obligations if they are prevented by or made unreasonably burdensome as a result of fire, explosion, natural disasters, war, unrest, states of emergency, seizure, currency restrictions, import / export bans, labor dispute and lack of transportation, general lack of materials due to or delay in delivery from subcontractors or other circumstances beyond the seller's control.",
  TermsAndConditionsSubText12:
    "To the extent that nothing else follows from mandatory statutory provision, the following applies regarding the seller's product liability: The seller is not liable for loss of property which is not a consequence of a personal or property damage covered by the seller's liability. The seller is not responsible for damage to real estate or movable property, just as the seller is not responsible for operating losses, profit losses or other indirect losses or damages. The seller is only liable for personal injury caused by the delivered products, if it can be documented that the damage caused is due to errors and negligence shown by the seller.",
  TermsAndConditionsSubText13:
    "Any disputes concerning agreements between buyer and seller must be settled by the Copenhagen City Court. Danish law applies.",
  TermsAndConditionsSubText14:
    "These terms of sale and delivery can only be deviated from by written agreement between the parties.",
  TermsAndConditionsSubText2:
    "Written offers from the seller are only bound to the seller if they are accepted in writing within 30 days from the date of the offer. Otherwise, the offer is deemed to have lapsed. Oral offers are not binding on the seller unless the seller sends written order confirmation to the buyer. The terms stated in the order confirmation are then valid. For custom-made goods, the seller reserves the right to change the offer in any respect until the seller's final approval of the buyer's draft or original material is available.",
  TermsAndConditionsSubText3:
    "All prices quoted are in Danish kroner and excl. VAT and any other turnover taxes. When ordering larger or smaller quantities than stated in the offer, the seller reserves the right to change the price and delivery time. Buyer is obliged to accept changes in the price until delivery, due to changes in the price from the seller's supplier as a result of documented increased costs for the seller, such as changes in customs, taxes, duties, etc., as a result of increased costs for the seller, so such as price increases on raw materials, changes in customs duties, taxes and duties, etc. If the seller's costs increase as a result of the buyer's circumstances, the seller can claim compensation for this. Discounts are only granted if agreed in writing.",
  TermsAndConditionsSubText4:
    "The payment terms are net cash upon receipt of the item by the buyer, unless otherwise agreed in writing in the order confirmation or invoice. If the buyer does not pay on time, a default interest of 2% per. commenced month. Agreed discounts are only granted if the payment is received on time. If delivery is postponed due to the buyer's circumstances (creditor mora), the buyer is obliged to make any payment to the seller as if delivery had taken place at the agreed time. If there is uncertainty about the buyer's ability to pay, including as a result of arrears to the seller, the seller is entitled to demand advance payment or security for payment of both already due receivables and for future amounts due. In the event of the buyer's default, the seller is entitled to cancel previously given commitments on payment deadlines of any kind. Offsetting in respect of undue or disputed claims can only be made by the buyer if the seller has given his consent in writing.",
  TermsAndConditionsSubText5:
    "The delivered remains the seller's property until the entire purchase price incl. freight, fee, etc. has been paid. Buyer is not entitled to set off any counterclaims.",
  TermsAndConditionsSubText6:
    "Delivery takes place from the seller's business address, regardless of whether the seller by his own people or by a third party in accordance with a separate agreement with the buyer brings the item for sale to the buyer. In that case, the buyer pays freight from the place of delivery as well as a handling fee. Delivery time is stated by the seller at best estimate in accordance with the conditions that exist at the time the offer is made / the agreement is entered into. In the event of changed conditions, the seller is entitled to postpone the delivery, but may without undue delay notify the buyer of the changed delivery time. If the delay in delivery is due to the seller being in a situation as specified in the section on limitation of liability, the delivery time is postponed by the time that the obstacle lasts. However, both parties are entitled to cancel the agreement without liability when the obstacle has lasted for more than 2 months. If the delivery has not taken place within 2 months after the stated delivery time, the buyer is entitled to state in writing to the company that the order will be canceled if delivery does not take place within 14 days after the company has received the notification. If the delivery does not take place before the expiry of the 14 days, the order is considered canceled.",
  TermsAndConditionsSubText7:
    "The 3D files and related blueprints provided by the buyer, for the purpose of manufacturing goods, are treated confidentially and destroyed at the buyer's request.",
  TermsAndConditionsSubText8:
    "Defects incurred as a result of inconvenience, unusual use or ordinary wear and tear are not covered by the seller's liability. Upon delivery, the buyer is obliged to inspect the item immediately upon receipt. Complaints must be submitted in writing within 8 days of receipt. If the buyer has discovered or should have discovered defects and not complained as stated, the buyer can not later claim the defect. At the seller's free choice, defects in the item for sale can be remedied or the seller can make a replacement. For the buyer's deficiency rights, reference is made to the general rules of Danish law in this regard. Modification and / or interference with the item for sale without the seller's written consent releases the seller from any obligation.",
  TermsAndConditionsSubText9:
    "Items are generally never returned. If the item for sale is to be returned, this can only be done by prior written agreement. In the event that a prior written agreement has been entered into regarding the right to return items for sale, return shipments must be in unbroken original packaging stating the date and number of the issued invoice. Should the right to return have been agreed, the seller reserves the right to deduct a seller's fixed fee for the return by crediting. Custom-made or custom-made items are never returned.",
  TermsAndConditionsTitel: "TERMS AND CONDITIONS",
  TermsOfTrade: "Terms and Conditions",
  Thread: "THREAD",
  ThreadCardDepth: "Hole depth",
  ThreadCardQuantity: "Quantity",
  ThreadCardDiameter: "Diameter",
  ThreadCardDepthErrorMsg1:
    "The depth of the hole exceeded the maximum depth for thread cutting! We only cut ",
  ThreadCardDepthErrorMsg2: "mm deep!",
  ThreadCardMaxDepth: "Max. depth: ",
  ThreadCardMixedThreads: "Mixed",
  ThreadCardNoThreads: "No Threads",
  ThreadCardSpecify: "Specify threads individually",

  Total: "Total",
  UpdateConfig: "UPDATE CONFIGURATION",
  UpgradingGuestWaitingMsg:
    "We are creating your account and moveing your guest basket over - One moment...",
  UploadBlueprint: "Upload Blueprint",
  UploadPdf: "Upload pdf",
  ClickUploadPdf: "Click to upload a pdf",
  UploadThreeDModel:
    "Drag n' drop your 3D models here or click to select files",
  UseCoupon: "USE",
  UserCreatedMsg: "Your account has been created! You can now log in!",
  WaitingMsg: "We are creating your user...",
  WarningChangesNotSaved:
    "Your changes will not be saved if you leave the component configurator now. NOTICE: changes to blueprints are always saved!",
  PONumber: "PO number",
  EANNumber: "GLN number (EAN)",
  WarningLoseConfig:
    "You will lose your configuration if you leave the component configurator now!",
  WeOffer: "We Offer",
  YesButton: "Yes",
  ZipInput: "Zip",
  WeTransferedYourBasket:
    "We have transfered your basket to your user. Check and confirm your basket.",
  AlreadyAUser: "Do you already have a user? Then login here.",
  AlreadyAUserBody:
    "Do you already have a user forgot to login then you can do it here. We will transfer this guest basket to your user and update your session.",
  ForgotLogin: "You forgot to login!",
  ConfirmingOrder: "Confirming your order...",
  NowLoggedIn: "You are now logged in!",

  OfferingPageMetaTitel: "CNC machining center distributor",
  OfferingPageMetaText:
    "CNC machining center EasyPartz offers easy online ordering of CNC milled items. Upload your 3D model, get a price immediately and delivery after a few days. Try it here!",
  OfferingPageH1: "CNC machining center",
  LoginPageMetaTitel: "CNC milling aluminum at EasyPartz",
  LoginPageMetaText:
    "CNC milling aluminum, plastic and other high quality materials. Register as a user, upload 3D model, get a price and order for delivery after a few days. Try it now!",
  LoginPageH1: "CNC aluminum milling ",
  AboutMetaTitel: "Machining and CNC milling",
  AboutMetaText:
    "High quality machining with fast delivery at EasyPartz online machine shop. Modernized and automated ordering of CNC milled items.",
  AboutH1: "CNC machining",
  CasesPageMetaTitel: "Milling aluminum at EasyPartz machine shop",
  CasesPageMetaText:
    "Milling aluminum, plastic and other materials with easy online ordering. Immediate price calculation and delivery in a few days. Order your urgent items cheaply here!",
  CasesPageH1: "Milling aluminum",
  KeyWords:
    "CNC Bearbejdning, Online maskinværksted, EasyPartz, Spåntagende bearbejdning, Fræsning aluminium",
  TNT1Titel: "TNT Express before 09:00",
  TNT1Body:
    "When your order is completed we will send your order with TNT express shipping to your address.",
  TNT1DeliveryTime: "Next day before 09:00",
  TNT2Titel: "TNT Express before 12:00",
  TNT2Body:
    "When your order is completed we will send your order with TNT express shipping to your address.",
  TNT2DeliveryTime: "Next day before 12:00",
  TNT3Titel: "TNT Express next day",
  TNT3Body:
    "When your order is completed we will send your order with TNT express shipping to your address.",
  TNT3DeliveryTime: "All day",

  // Front Page Content
  FrontPageMetaTitel: "CNC machining with EasyPartz",
  FrontPageMetaText:
    "CNC machining at EasyPartz online machine shop. Upload your 3D model, get instant price and delivery in just a few days. Simple and fast. Try it now!",
  FrontPageH1: "Machine shop - The easy way",
  FrontPageH2: "Order CNC machined components in 2 minutes",
  FrontPageH3:
    "EasyPartz is your online machine shop, where you can order custom components easily and and get them quickly. Upload your 3D model - price and delivery will be calculated immediately - and you will receive your items after a few days. Quick and easy, so you can spend your time on value-adding tasks.",
  FrontPageH3Sub:
    "Du er også velkommen til at maile 3D modeller og arbejdstegninger til info@easypartz.com, så vender vi tilbage med et tilbud hurtigst muligt, typisk inden for få timer.",
  FrontPageTextOpen247Titel: "Open 24/7 all year round!",
  FrontPageTextOpen247:
    "We are open 24 hours a day, so you are no longer dependent on opening hours or long response times. EasyPartz machine shop works like a normal webshop. Order when it suits you, avoid unnecessary email correspondence, and move on quickly. At EasyPartz, we specialize in small and medium-sized series, and no order is too small. We supply from 1 to 1,000 items and are the perfect solution for manufacturing both machine parts, special equipment, prototypes, spare parts and components for small production series.",
  FrontPageTextServiceTitel: "Top Class Service and Support",
  FrontPageTextService:
    "Do you need technical sparring to optimize your design, guidance in materials and finishes, or questions for our service and online calculator? Then feel free to contact us using chat, email or phone, and our competent employees will be ready to answer all of your questions.",
  FrontPageTextSatisfactionTitel: "100% Satisfaction Guarantee",
  FrontPageTextSatisfaction:
    "EasyPartz offer you a 100% satisfaction guarantee on all orders. If you are not satisfied with the parts manufactured, you can return them and get a full refund. This is why you will only benefit from trying EasyPartz Machine Shop as your new supplier of CNC machined items. You get the best possible service, since we are always available on chat, email, phone, and video chat if you have technical questions or special requests that do not appear in the web shop.",
  FrontPageTextHowToTitel: "How do I order?",
  FrontPageTextHowTo:
    "Upload your 3D model in the box above, and you're off! We accept .stp / .step files (and soon also .igs / .iges) which can be exported in all common 3D modeling and CAD programs. Once the model is uploaded, it only takes a few seconds before you have a price. You then have the opportunity to choose the number of pieces, material, finishing, thread and tolerances. You do not even have to make technical drawings! EasyPartz also performs an automatic DFM (Design-for-Manufacturing) analysis, which identifies and visualizes the most common design errors, why you immediately get feedback on how to optimize your design. When you have finished configuring your component, you can add it to the basket, and continue ordering more designs or proceed to complete your order. If you need help, you are always welcome to contact us via chat, email or phone.",
  FrontPageTextSpeedTitel: "How quick is it?",
  FrontPageTextSpeed:
    "At EasyPartz Machine Shop, we know that speed is one of the most important factors when ordering manufactured prototypes and other components. This is why we have made the ordering process as easy and simple as possible, so you no longer need to spend time on slow communication back and forth, but instead can focus on value-creating tasks. We also strive to produce your order within 4 working days, and also ensure that both post-processing and shipping takes place as quickly as possible. Before long, you will even be able to follow the production of your components directly on the order overview.",
  FrontPageTextPriceTitel: "How much does it cost?",
  FrontPageTextPrice:
    "EasyPartz machine shop uses original machines, equipment and software that automate the production of even the smallest orders. We can therefore offer fast delivery at extremely attractive prices. It is especially with small series that we are very competitive, as we have simplified and automated programming, preparation and setup, which traditionally make up the majority of the production costs. Try uploading a 3D model in the box above, and get the price calculated in a few seconds. If your order consists of many items of a single design, we are happy to help optimize both design and production method to give you the best price.",
  FrontPageTextTechonolgyTitel: "How is this possible?",
  FrontPageTextTechonolgy:
    "At EasyPartz, we have developed original machines, equipment and software that enable us to automate and simplify the production of CNC milled items. It is especially the knowledge-intensive manual processes in connection with programming (CAM), preparation and setup that we have focused on optimizing. Processes which are often downgraded by machine shops, who will rather focus on a few large orders than many small orders. You can read more about our technologies on the About Us page, or by following us on Youtube, Facebook or LinkedIn.",
  FrontPageTextServicesTitel: "What can you manufacture?",
  FrontPageTextServices:
    "At EasyPartz, we are focused on CNC milling. CNC Milling (also known as CNC machining) is a machining process in which a computer-controlled machine removes material bit by bit until only the finished component remains. CNC milling is a very versatile production technology, where very high tolerances can be achieved, while working in most well-known materials, and in all sizes and levels of detail. You can read more about the possibilities and limitations of CNC machined items in our Design Guide. We manufacture components in many common types of plastic, aluminum and other soft metals, and before long we will also open for manufacturing stainless steel.",
  Case1: `"We used to wait for days on offers and weeks for parts to arrive. EasyPartz instantly calculates price and delivery time, and we receive the components in just a few days. This is a great advantage for us."`,
  Case2: `"When we design new products, it's nice to have a supplier like EasyPartz who is flexible, delivers quickly, and where we can also get technical sparring in relation to production optimization. We have used EasyPartz to manufacture both prototypes and 0-series, and they are happy to share their expertise in design and production technology, so we can optimize our designs. "`,
  Case3: `"We use EasyPartz as a subcontractor of milled plastic and aluminium components, because it is flexible, there is a short delivery time and they deliver on time. With Vaerks, we have been able to scale production in line with the demand for our products, from prototype to several hundred units. It has been a great advantage for us, because we have avoided early investment in expensive injection molds."`,
  UploadSuccessMsg:
    "The file was successfully uploaded. Please wait while we analyze it.",
  UploadFailedMsg:
    "The file could not be uploaded. Please try again later or contact us for help.",
  ComingSoon: "Coming soon!",
  ChangeModel: "Change model",
  StayDEMO: "Stay at demo",
  BasketSummaryFees: "Fees",
  BasketSummaryLeadtimeHeader: "Lead Time",
  BasketSummaryLeadTimeSubHeader: "Workdays",
  BasketSummaryLeadtimeText: "days",
  BasketExternalSupplier: "External Supplier",
  BasketExternalSupplierTooltip:
    "Ordrer med lang leveringstid produceres af EasyPartz's partnere. Data videregives derfor til tredjeparter.",
  UserModalTitle: "Your EasyPartz User",
  UserModalText:
    "To upload your custom models, you need to create a user. This allows you to configure your own components and make an order with us.",
  BeforeWeStart: "Before we start..",
  BeforeWeStartText:
    "Before we start you must log in or create a user. Afterwards you can upload your model!",
  BeforeWeStartMoreBtn: "Want to hear more?",
  BeforeWeStartTryDemo:
    "If you want to see the options before you create a user then click here %s to try it out on our demo model.",
  here: "here",
  PleaseLoginText:
    "To upload a model you need to be logged in. If you do not have a user you can easily create one, it only takes 2 minutes.",
  LoginOrRegister: "LOGIN / CREATE USER",
  fetchingPrice: "Updating price...",
  LongDeliveryTime:
    "We are working on on a downsized  in the summer, and because of this you can expect longer delivery in the weeks, 26, 30, 31 and 32.",
  ClosedChristmas: "We are closed for between Christmas and New Year.",

  OrderTitle: "Thank you for your order.",
  OrderSubtext:
    "We have received your order and within a few minutes you will receive a confirmation to your email. If you have any questions, please contact us with the chat or email.",
  details: "Details",
  orderNumber: "Order number",
  date: "Date",
  email: "Email",
  paymentMethod: "Payment method",
  deliveryMethod: "Delivery method",
  invoiceAddress: "Invoice address",
  deliveryAddress: "Delivery address",
  products: "Products",
  name: "Name",
  material: "Material",
  quantity: "Quantity",
  finish: "Finish",
  price: "Price",
  unit: "pcs",
};

export default en_gb;
